import { Directive, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NavService } from '../../core/nav.service';
import { Course } from '../../courses/shared/course';
import { Lecture } from '../shared/lecture';

@Directive({
  selector: 'app-lecture-detail-nav' // tslint:disable-line:directive-selector
})
export class LectureDetailNavDirective implements OnDestroy {
  private _course: Course;
  private _lecture: Lecture;

  constructor(private route: ActivatedRoute, private nav: NavService) { }

  ngOnDestroy() {
    this.nav.navList = null;
  }

  @Input() set course(course: Course) {

    this._course = course;

    if (course) {
      this.nav.navTitle = course.name;
    }
  }

  @Input() set lecture(lecture: Lecture) {

    this._lecture = lecture;

    if (lecture) {
      this.nav.title = { text: lecture.name, commands: ['.'], route: this.route };
      this.nav.navActivated = [lecture.$key];
      this.nav.lecturePublic = lecture.public;
    }
  }

  @Input() set lectures(lectures: any[]) {

    if (lectures) {
      this.nav.navList = {
        title: this._course ? this._course.name : 'Lectures',
        items: lectures.map(lecture => ({
          observableText: lecture.name,
          commands: [lecture.$key],
          route: this.route.parent
        })),
      };
      this.nav.navActivated = this._lecture ? [this._lecture.$key] : null;
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-detail/lecture-detail-nav.directive.ts